import { apiClient } from "../config";

async function getAllUserWhichCanBeAddAsAdmin(
  organizationId: string,
  searchString: string,
  page: number,
  appName? : string
) {
  const params = {
    organizationId,
    search_string: searchString.trim() !== "" ? searchString : undefined,
    page,
    appName
  };

  const response = await apiClient.get("/admin/programs/admins-dropdown", {
    params,
  });

  return response.data;
}

export default getAllUserWhichCanBeAddAsAdmin;